/* loaded by smart-asset */
export default require("./eyesee-hub~EDpxOxZP.png")